import ApiService from '../api.service';

const Posts = {
  index: (params) => ApiService.query('/api/v2/teachers/me/posts', params),
  show: (postId) => ApiService.get(`/api/v2/teachers/me/posts/${postId}`),
};

export default Posts;
